import http from '@/services/http'

const initialErrors = {
  email: [],
}

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    actionInProgress: false,
    owners: [],
    errors: initialErrors,
  },
  mutations: {
    startFetch(state) {
      state.fetchInProgress = true
    },
    stopFetch(state) {
      state.fetchInProgress = false
    },
    setData(state, { owners }) {
      state.owners = owners
    },
    setErrors(state, { errors }) {
      state.errors = errors
    },
    clearErrors(state) {
      state.errors = initialErrors
    },
    startAction(state) {
      state.actionInProgress = true
    },
    stopAction(state) {
      state.actionInProgress = false
    },
    added(state, { id, email }) {
      state.owners.push({ id, email })
    },
    removed(state, { id }) {
      state.owners = state.owners.filter((o) => o.id !== id)
    },
  },
  actions: {
    async fetch({ commit }, { startupId }) {
      commit('startFetch')
      try {
        const url = `/startups/${startupId}/owners`
        const response = await http.getAuthed(url)
        commit('setData', { owners: response.data })
      } catch (error) {
        if (error.response) {
          commit('setErrors', error.response.data)
        }
        throw error
      } finally {
        commit('stopFetch')
      }
    },
    async add({ commit }, { startupId, email }) {
      commit('startAction')
      try {
        const url = `/startups/${startupId}/add-owner`
        const response = await http.postAuthed(url, { email })
        commit('added', { email, id: response.data.user_id })
        commit('clearErrors')
      } catch (error) {
        if (error.response) {
          commit('setErrors', { errors: error.response.data })
        }
        throw error
      } finally {
        commit('stopAction')
      }
    },
    async remove({ commit }, { startupId, userId }) {
      commit('startAction')
      try {
        const url = `/startups/${startupId}/remove-owner`
        await http.postAuthed(url, { user_id: userId })
        commit('removed', { id: userId })
      } catch (error) {
        if (error.response) {
          commit('setErrors', { errors: error.response.data })
        } else {
          throw error
        }
      } finally {
        commit('stopAction')
      }
    },
  },
}
